import type { EventCategory } from "@/lib/events";

/** Default capacity when not stored on the event (by venue category). */
export const DEFAULT_EVENT_CAPACITY: Record<EventCategory, number> = {
  Bars: 80,
  Clubs: 250,
  Concerts: 800,
  Rooftop: 150,
};

export function capacityForCategory(category: EventCategory): number {
  return DEFAULT_EVENT_CAPACITY[category];
}
